export default class DetailWriteDTO {

    public id: number | undefined;
    public name: string | undefined;
    public isNamingRelevant: boolean;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined
        this.name = data['name'] || undefined
        this.isNamingRelevant = data['isNamingRelevant'] || false;
    }

}